import { classificationTabs } from './classification-tabs';

const openDialog = (e: Event) => {
    const portfolio = (e.currentTarget as HTMLElement)?.closest('.portfolio-section__portfolio');
    portfolio?.querySelector<HTMLDialogElement>('.portfolio-section__dialog')?.showModal();
}

const closeDialog = (e: Event) => {
    (e.currentTarget as HTMLElement)?.closest<HTMLDialogElement>('.portfolio-section__dialog')?.close();
}

const handleBackdropClick = (e: MouseEvent) => {
    const rect = (e.currentTarget as HTMLDialogElement)?.getBoundingClientRect()
    const isInDialog =
        rect.top <= e.clientY &&
        e.clientY <= rect.top + rect.height &&
        rect.left <= e.clientX &&
        e.clientX <= rect.left + rect.width
    if (!isInDialog) (e.currentTarget as HTMLDialogElement)?.close()
}

const setActiveFilterButton = (buttonType: 'current' | 'previous') => {
    sessionStorage.setItem('activeFilterButton', buttonType);
    document.querySelectorAll<HTMLButtonElement>('.time-filters button').forEach(button => {
        const selected = button.classList.contains(`${buttonType}-filter`);
        button.classList.toggle('active', selected);
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        if (selected) document.getElementById('investment-panel')?.setAttribute('aria-labelledby', button.id);
    });
    document.querySelectorAll<HTMLElement>('.portfolio-section').forEach(portfolioSection => {
        portfolioSection.classList.toggle('portfolio-section--show-current', buttonType === 'current');
        portfolioSection.classList.toggle('portfolio-section--show-previous', buttonType === 'previous');
    });
};

export const portfolio = () => {
    const portfolioSections = document.querySelectorAll<HTMLElement>('.portfolio-section');

    if (!portfolioSections.length) {
        return;
    }

    portfolioSections.forEach(portfolioSection => {
        portfolioSection?.querySelectorAll<HTMLElement>('.portfolio-section__portfolio')
            .forEach(portfolio => {
                portfolio.querySelector('.portfolio-section__logo')?.addEventListener('click', (e) => openDialog(e));
                portfolio.addEventListener('keydown', (e) => {
                    if (e.target === portfolio && (e.key === 'Enter' || e.key === ' ')) {
                        e.preventDefault();
                        openDialog(e);
                    }
                });
                portfolio.querySelector('.portfolio-section__dialog--close')?.addEventListener('click', (e) => closeDialog(e));
                portfolio.querySelector('.portfolio-section__dialog')?.addEventListener('click', (e) => handleBackdropClick(e as MouseEvent));
            });

    });

    const tabList = document.querySelector('.time-filters');
    if (tabList) {
        const tabs = Array.from(tabList.querySelectorAll<HTMLButtonElement>('button'));
        const content = document.querySelectorAll('.classification-tabs, .portfolio-section');
        const panel = document.createElement('div');
        panel.id = 'investment-panel';
        panel.setAttribute('role', 'tabpanel');
        content[0].before(panel);
        panel.append(...content);
        const mobile = window.matchMedia('(max-width: 1024px)');
        const setOrientation = () => tabList.setAttribute('aria-orientation', mobile.matches ? 'vertical' : 'horizontal');
        setOrientation();
        mobile.addEventListener('change', setOrientation);

        tabs.forEach((tab, index) => {
            const type = tab.classList.contains('current-filter') ? 'current' : 'previous';
            tab.addEventListener('click', () => setActiveFilterButton(type));
            tab.addEventListener('keydown', event => {
                const keys = mobile.matches ? ['ArrowUp', 'ArrowDown'] : ['ArrowLeft', 'ArrowRight'];
                if (!keys.includes(event.key)) return;
                event.preventDefault();
                const next = tabs[(index + (event.key === keys[1] ? 1 : -1) + tabs.length) % tabs.length];
                next.click();
                next.focus();
            });
        });
        setActiveFilterButton(sessionStorage.getItem('activeFilterButton') === 'previous' ? 'previous' : 'current');
    }

    classificationTabs('.portfolio-section__portfolio', '.portfolio-section', 'Portfolio industries');

    const urlParams = new URLSearchParams(window.location.search);
    const typeParam = urlParams.get('type');
    let hadFilter = false;
    
    if (typeParam && typeParam != "") {
        const matchFilter: any = document.querySelector(`.classification-tabs > a[data-title="${encodeURIComponent(typeParam.toLocaleLowerCase())}"]`);

        if (matchFilter) {
            matchFilter.click();
            hadFilter = true;
        }
    }

    if (!hadFilter && document.querySelector('.classification-tabs a')) {
        document.querySelectorAll('.classification-tabs > a')[0].classList.add('active');
    }
};

